import React, { useContext } from "react";
import { useMutation } from "@apollo/react-hooks";
import { makeStyles } from "@material-ui/styles";
import Booking from "./booking";
import gql from "graphql-tag";
import { Button, Container, Grid } from "@mantine/core";
import PaymentCountdown from "./paymentCountdown";
import _ from "lodash";
import moment from "moment";
import { AppContext, OPEN_TOAST } from "../Context";
import "../Common/unpaid.css";
import { uriWithCulture } from "./util";

const PAY_BOOKING = gql`
  mutation initiatePayment {
    initiatePayment {
      uri
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  bookingsList: {
    marginTop: "1rem",
    // height: (p) => (p.anyUnpaid ? "calc(100% - 135px)" : "calc(100% - 250px)"),
    // height: "100%",
    overflow: "auto",
    "@media screen and (max-width: 600px)": {
      height: "100% !important",
      margin: 0,
      // height: (p) =>
      //   p.anyUnpaid ? "calc(100% - 225px)" : "calc(100% - 186px)",

      overflowY: "scroll",
      "-webkit-overflow-scrolling": "touch",
    },
  },
  list: {
    listStyle: "none",
    margin: "0 auto",
    paddingLeft: 0,
    marginTop: "1px",
    width: 1024,
    "@media (max-width: 1300px)": {
      width: "77%",
    },
    "@media (max-width: 1024px)": {
      width: "100%",
      // margin: 0,
    },
  },
}));

const BookingsList = (props) => {
  const {
    bookings,
    anyUnpaid,
    language,
    locale,
    mybookings,
    checkoutEnabled,
    selected,
    culture
  } = props;
  const classes = useStyles({ anyUnpaid });
  const context = useContext(AppContext);
  const { dispatch, state } = context;
  const handleMutationSuccess = (data) => 
  (window.location = uriWithCulture(data.initiatePayment.uri, culture));

  const handleMutationError = (error) =>
    dispatch({ type: OPEN_TOAST, toastText: error, toastType: "error" });
  const [initiatePayment] = useMutation(PAY_BOOKING, {
    onError: handleMutationError,
    onCompleted: handleMutationSuccess,
  });

  const payableBookings =
    mybookings && mybookings.filter((b) => b.isConfirmed && !b.isPaid);
  const nextPayment = _.chain(payableBookings)
    .filter((x) => x.lastPaymentTime)
    .map((x) => moment(x.lastPaymentTime))
    .sort()
    .min()
    .value();
  return (
    <div className={classes.bookingsList}>
      {payableBookings &&
      payableBookings?.length > 0 &&
      selected === "confirmed" ? (
        <Container
          className="paymentTime"
          my="xs"
          radius="md"
          sx={(theme) => ({
            backgroundColor: theme.colors.red[9],
            borderRadius: theme.radius.sm,
            padding: 0,
          })}
          role="alert"
        >
          <PaymentCountdown
            next={nextPayment}
            locale={locale}
            language={language}
          />
        </Container>
      ) : (
        ""
      )}

      <ul className={classes.list}>
        {bookings.map((b, i) => (
          <Booking key={i} booking={b} />
        ))}
        {anyUnpaid &&
        payableBookings &&
        payableBookings?.length > 0 &&
        checkoutEnabled &&
        selected === "confirmed" ? (
          <Grid
            justify="end"
            style={{ maxWidth: 1024, padding: 0, margin: "1rem 0" }}
            sx={(theme) => ({
              "@media (max-width: 768px)": {
                display: "none",
              },
            })}
          >
            <Button
              color="violet.9"
              varianti="filled"
              radius="sm"
              size="md"
              onClick={initiatePayment}
            >
              {language.pay}
            </Button>
          </Grid>
        ) : (
          ""
        )}
      </ul>
    </div>
  );
};

export default BookingsList;
